<div *ngIf="!people || people.length === 0">
  <em>No people to display</em>
</div>
<div *ngIf="people && people.length > 0">
  <table class="table table-border">
    <thead>
      <tr>
        <th style="width: 50px"></th>
        <th>Name</th>
        <th>Date Hired</th>
        <th>Email</th>
        <th>Phone Number</th>
        <th>Last Paid</th>
        <th *ngIf="status != 'TERMINATED' && status != 'INACTIVE' && isWhitelistedWithPermission">
          Registration Status
        </th>
        <th *ngIf="status != 'TERMINATED' && status != 'INACTIVE' && isWhitelistedWithPermission">
          Resend Invite
        </th>
      </tr>
    </thead>
    <tbody>
      <tr data-testid="people-row" *ngFor="let person of getPeopleByLastName()">
        <td><i class="far fa-3x fa-user-circle"></i></td>
        <td>
          <a routerLink="/client/{{ clientCode }}/person/{{ person.Id }}">
            <strong>
              {{ person.LastName }}<span *ngIf="person.FirstName">, {{ person.FirstName }}</span>
            </strong>
          </a>
        </td>
        <td>{{ person.HireDate | date: 'MM/dd/yyyy' }}</td>
        <td>{{ person.PersonalEmailAddress }}</td>
        <td>{{ person.HomePhoneNumber | mask: '(000) 000-0000' }}</td>
        <td>{{ person.LastPaid | date: 'MM/dd/yyyy' }}</td>
        <td *ngIf="status != 'TERMINATED' && status != 'INACTIVE' && isWhitelistedWithPermission">
          {{ getRegistrationStatus(person.Id) }}
        </td>
        <td *ngIf="status != 'TERMINATED' && status != 'INACTIVE' && isWhitelistedWithPermission">
          <button
            *ngIf="allowRegistrationResend"
            (click)="resendRegistration(person.Id)"
            class="btn btn-primary resend">
            Resend
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <lib-pagination [pagination]="pagination" (pageChanged)="loadPage($event)"></lib-pagination>
</div>
